import state from '@/state';
import { getFallback } from './fallback';

function handleStringOrObject(value, language = state.locale.lang.toLowerCase()) {
    if (typeof value === 'string') {
        return value;
    } else if (typeof value === 'object') {
        const lowerCaseLocalizedStrings = Object.keys(value).reduce((acc, key) => ({ ...acc, [key.toLowerCase()]: value[key] }), {});
        return getFallback(lowerCaseLocalizedStrings, null, language.toLowerCase(), 'en');
    }
    return '';

}

export const getLocalizedString = (merchantConfigParam) => {
    return handleStringOrObject(merchantConfigParam);
};